var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DashboardCardScaffold",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex flex-inline items-center" },
                [
                  _c(
                    "RouterLink",
                    {
                      staticClass: "hover:text-primary-500",
                      attrs: {
                        to: {
                          name: _vm.routes.MANAGE_MANAGERS,
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "font-bold text-lg" }, [
                        _vm._v("Managers"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "managerdetail",
          fn: function () {
            return [
              _c("ManagersTable", {
                attrs: {
                  managersTable: _vm.managers,
                  isManager: _vm.isManager,
                  isAdmin: _vm.isAdmin,
                  currentUserId: _vm.currentUserId,
                  itemLink: _vm.requestsLink,
                },
                on: { refresh: _vm.refreshPage },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "invitebtn",
          fn: function () {
            return [
              _vm.isAdmin
                ? _c("ManagerInvitationModalWithButton", {
                    staticClass: "flex flex-grow justify-end mt-40",
                    attrs: {
                      companyId: _vm.companyId,
                      companyBusinessName: _vm.companyBusinessName,
                      managersUnlimited: !_vm.subscriptionRequired,
                      accessAllowedManagersCount:
                        _vm.accessAllowedManagersCount,
                      activeManagersCount: _vm.activeManagersCount,
                      company: _vm.company,
                      currentUser: _vm.currentUser,
                    },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "CardItemScaffold",
        {
          staticClass: "mb-2 text-innerCard-primary",
          attrs: {
            itemNumber: _vm.managersTotalMinusViewer,
            itemTitle: "Managers",
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("SimplePersonIcon", {
                    staticClass: "fill-current text-primary-500 h-5 w-5",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("ItemChipsWithMore", {
            attrs: {
              items: _vm.managersInfo,
              moreNumber: _vm.managersTotalMinusViewer,
              routeName: _vm.routes.MANAGER_ABOUT,
              navigateTo: { name: _vm.routes.MANAGE_MANAGERS },
              maxChipWidth: "max-w-40",
              isPerson: "",
            },
          }),
        ],
        1
      ),
      _vm.isAdmin
        ? _c(
            "CardItemScaffold",
            {
              staticClass: "text-innerCard-primary",
              attrs: {
                itemNumber: _vm.requestsTotal,
                itemTitle: _vm.requestItemTitle,
                itemLink: _vm.requestsLink,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "icon",
                    fn: function () {
                      return [
                        _c("SimplePersonIcon", {
                          staticClass: "fill-current text-primary-500 h-5 w-5",
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                917959621
              ),
            },
            [
              _c("p", { staticClass: "text-gray-600 text-sm" }, [
                _vm._v(
                  "A Manager has requested access to a Contractor and requires approval."
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }